export default "__VITE_ASSET__4415bc81__"